import { render, staticRenderFns } from "./DeptRatioCalculator.vue?vue&type=template&id=7e8b0556&scoped=true&"
import script from "./DeptRatioCalculator.vue?vue&type=script&lang=ts&"
export * from "./DeptRatioCalculator.vue?vue&type=script&lang=ts&"
import style0 from "./DeptRatioCalculator.vue?vue&type=style&index=0&id=7e8b0556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8b0556",
  null
  
)

export default component.exports